export const MachineType = Object.freeze({
        DefaultModel: 0,
        //UndergroundDrilling = 1,
        //BoltingRig = 2,
        BoltTensileTester: 21,
        //WorkingPlatform = 4,
        GroutingSystem: 5,
        //GuardRailInstallationRig = 6,
        ShotcreteRobots: 7,
        //SurfaceDrillingRigEquipment = 8,
        //BoxHoleDrillingRig = 9,
        //SurfaceDrilling = 10,
        DrillingJumbo: 11,
        //ChargingRig = 12,
        //ConcreteElementLifting = 13,
        //FrontLoader = 15,
        //ContreteElementLifter = 16,
        //SurfaceDrillingRig = 17,
        //MiniTBM = 18,
        GroutingRigTCP: 50,
        GroutingRigSKID: 51,
        GroutingRigNextGen: 52,
        LidarTunnel: 100,
        LidarMine: 101
});